import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import FireIcon from '../../assets/fire-icon.svg';
import ArticleContainer from '../../components/ArticleContainer';
import { useGetListArticleByFilter } from '../../hooks/useGetListArticleByFilter';
import GoBackButton from '../../components/GoBackButton';
import SEO from '../../components/SEO';
import { generateSEOMetadata, collectionPages } from '../../utils/seo';

const BreakingNewsPage = () => {
  const navigate = useNavigate();

  const getTotalTopic = (amount) => {
    return amount;
  };

  const { loading, listArticle, total } = useGetListArticleByFilter({ type: 'breaking' });

  // Generate SEO metadata for breaking news page
  const seoMetadata = generateSEOMetadata.collectionPage(
    collectionPages['breaking-news'].name,
    collectionPages['breaking-news'].url,
    collectionPages['breaking-news'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      <div className="w-full flex flex-start flex-col px-4 md:px-0 relative">
        <GoBackButton
          onClick={() => {
            navigate('/');
            window.scrollTo(0, 0);
          }}
        />
        <div className="flex sticky top-[68px] md:top-[80px] pt-3 md:pt-10 z-20 mx-[-16px] bg-white">
          <div className="w-full">
            <div className="text-center text-[20px] gap-2 md:text-[32px] font-[800] text-growth-green-500 flex items-center justify-center">
              Breaking News
              <img src={FireIcon} className="w-[36px] h-[36px]" alt=""></img>
            </div>
            <p className="text-sm md:text-[24px] text-center font-[700] text-02-dim-gray mt-1 md:mt-2">
              {getTotalTopic(total)} Stories
            </p>
          </div>
        </div>
        <div className="max-w-[604px] w-full mx-auto flex mt-10">
          <ArticleContainer
            loading={loading}
            listArticle={listArticle ?? []}
            isHiddenFeaturedArticles
            isProfile
          />
        </div>
      </div>
    </div>
  );
};

export default BreakingNewsPage;
